import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DeclarerRetourPlateformeDialogContent from './DeclarerRetourPlateformeDialogContent';
import withLoader from 'components/Shared/withLoader';
import { sansDepotMagasin } from 'utils/depotHelper';

const DeclarerRetourPlateformeDialogContentWithLoader = withLoader(DeclarerRetourPlateformeDialogContent);

class DeclarerRetourPlateformeDialogContentContainer extends React.Component {
    

    render() {
        const { onChange, action, isLoading, reclamationMagasin, plateformeVaulx } = this.props;

        let codeDepot = reclamationMagasin ? reclamationMagasin.codeDepot : '';
        if (codeDepot === '') {
            let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

            if (sansDepotMagasin(utilisateur)) {
                if (utilisateur.depots && utilisateur.depots.length === 1) {
                    codeDepot = utilisateur.depots[0].code;
                }
            }
            else {
                codeDepot = utilisateur.depot.code;
            }
        }

        return (
        <DeclarerRetourPlateformeDialogContentWithLoader
            isLoading={isLoading}
            onChange={onChange}
            action={action}
            codeDepot={codeDepot}
            plateformeVaulx={plateformeVaulx}
        />);
    }
}

DeclarerRetourPlateformeDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};



const mapStateToProps = (state, props) => {
    let depotDepart = "01";
    if (state.reclamation.details && state.reclamation.details.qualifications && state.reclamation.details.qualifications.piece) {
        depotDepart = state.reclamation.details.qualifications.piece.depotDepart;
    }
    let plateformeVaulx = (depotDepart === "70");

    return {

        reclamationMagasin: state.reclamation.details && state.reclamation.details.qualifications ? state.reclamation.details.qualifications.depot : null,       

        plateformeVaulx: plateformeVaulx
    };
};


const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(DeclarerRetourPlateformeDialogContentContainer);